import type { AbstractControl, ValidatorFn } from '@angular/forms';

export function customPhoneNumberValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        const phoneNumber = control.value;
        if (!phoneNumber) {
            return null;
        }
        return phoneNumber.trim() === '' ? { phoneNumber: true } : null;
    };
}
